import React from 'react'

import PreviewTextFieldSkeleton from '../PreviewTextFieldSkeleton'

function SkeletonWebsiteText({ className, count, isInProgress, showLoadingAnimation }) {
  return (
    <PreviewTextFieldSkeleton
      isInProgress={isInProgress}
      count={count}
      className={className}
      showLoadingAnimation={showLoadingAnimation}
    />
  )
}

export default SkeletonWebsiteText
